import styled, { css } from 'styled-components'

export interface SectionTitleStyledProps {
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    .title {
      font-size: ${({ theme }) => theme.typography.fontSize.section};
      font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
      margin-bottom: 2px;
    }
    .subtitle {
      font-size: ${({ theme }) => theme.typography.fontSize.micro};
    }
  `,
  medium: css`
    .title {
      font-size: ${({ theme }) => theme.typography.fontSize.title};
      font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
      margin-bottom: 4px;
    }
    .subtitle {
      font-size: ${({ theme }) => theme.typography.fontSize.small};
    }
  `,
  large: css`
    .title {
      font-size: 16px;
      font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
      margin-bottom: 4px;
    }
    .subtitle {
      font-size: ${({ theme }) => theme.typography.fontSize.body};
    }
  `,
}

export const Container = styled.div<SectionTitleStyledProps>`
  display: flex;
  flex-direction: column;
  flex: 1;

  .title {
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: ${({ theme }) => theme.typography.fontFamily.sans};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    margin: 0;
  }

  .subtitle {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-family: ${({ theme }) => theme.typography.fontFamily.sans};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    margin: 0;
  }

  ${({ $size = 'medium' }) => sizeStyles[$size]}
`
